"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = require("../../index");
const ListCards_1 = require("./poolscalls/ListCards/ListCards");
const ListPools_1 = require("./poolscalls/ListPools/ListPools");
const ListRaces_1 = require("./poolscalls/ListRaces/ListRaces");
const GetWillPays_1 = require("./poolscalls/GetWillPays/GetWillPays");
const GetRaces_1 = require("./poolscalls/GetRaces/GetRaces");
const GetResults_1 = require("./poolscalls/GetResults/GetResults");
const GetProbables_1 = require("./poolscalls/GetProbables/GetProbables");
class IAPIPoolsClient extends index_1.IAPIClient {
    constructor(params) {
        super(params);
        this.listCards = ListCards_1.listCards.bind(this);
        this.listRaces = ListRaces_1.listRaces.bind(this);
        this.listPools = ListPools_1.listPools.bind(this);
        this.getRaces = GetRaces_1.getRaces.bind(this);
        this.getWillPays = GetWillPays_1.getWillPays.bind(this);
        this.getResults = GetResults_1.getResults.bind(this);
        this.getProbables = GetProbables_1.getProbables.bind(this);
    }
}
exports.default = IAPIPoolsClient;
